const RegisteredDialogsStore: SimpleObject<any> = {};
export default RegisteredDialogsStore;
